import { Subject } from 'rxjs';

export enum EmailFilterEventType {
    change
}

export class EmailFilterConfig {
    config: any[];
    events$: Subject<{ type: EmailFilterEventType, payload: any[] }>;
    constructor() {
        this.events$ = new Subject();
        this.config = [];
    }
}

export const StandardFilterItems: Array<{ text: string, value: string, type: string, hide?: boolean }> = [
    { text: 'Subject', value: 'Subject', type: 'standard' },
    { text: 'Note Type', value: 'NoteType', type: 'standard' },
    { text: 'Entity Type', value: 'EntityType', type: 'standard' },
    { text: 'Entities', value: 'Entities', type: 'standard' },
    { text: 'Display Date', value: 'DisplayDate', type: 'standard' },
    { text: 'Submitted Date', value: 'SubmittedDate', type: 'standard' },
    { text: 'Last Modified Date', value: 'LastModifiedDate', type: 'standard' },
    { text: 'Source', value: 'Source', type: 'standard' },
    { text: 'Submitter', value: 'Submitter', type: 'standard' },
    { text: 'Priority', value: 'Priority', type: 'standard' },
    { text: 'Sentiment', value: 'Sentiment', type: 'standard' },
    { text: 'Team', value: 'Team', type: 'standard' },
    { text: 'Location', value: 'Location', type: 'standard' },
    { text: 'Start Time', value: 'StartTime', type: 'standard' },
    { text: 'End Time', value: 'EndTime', type: 'standard' },
    { text: 'Participants', value: 'Participants', type: 'standard' }
];

export const StandardFileFilterItems: Array<{ text: string, value: string, type: string, hide?: boolean }> = [
    { text: 'File Name', value: 'FileName', type: 'standard' },
    { text: 'File Type', value: 'FileType', type: 'standard' },
    { text: 'Subject', value: 'Subject', type: 'standard' },
    { text: 'Note Type', value: 'NoteType', type: 'standard' },
    { text: 'Entity Type', value: 'EntityType', type: 'standard' },
    { text: 'Entities', value: 'Entities', type: 'standard' },
    { text: 'Display Date', value: 'DisplayDate', type: 'standard' },
    { text: 'Submitted Date', value: 'SubmittedDate', type: 'standard' },
    { text: 'Source', value: 'Source', type: 'standard' },
    { text: 'Submitter', value: 'Submitter', type: 'standard' },
    { text: 'Priority', value: 'Priority', type: 'standard' },
    { text: 'Sentiment', value: 'Sentiment', type: 'standard' },
    { text: 'Team', value: 'Team', type: 'standard' }
];

